export const TYPES = {
  NORMAL: 'normal',
  SHOW: 'show',
  EDIT: 'edit',
};
